// Lightweight debug logger. Diagnostic console.log noise is gated behind the
// Vite dev flag so it never ships to production builds (and never leaks payload
// data to end-user browser consoles). Errors keep going to console.error.
const isDev = Boolean(import.meta.env && import.meta.env.DEV);

export const logger = {
  debug: (...args) => {
    if (isDev) console.log(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;
